import React, { useEffect } from "react";
import { useAuth } from "modules/authentication/hooks/use-auth";
import { AcquirePlusDialog } from "modules/subscription/components/AcquirePlusDialog";

/**
 * Renders the 403 `plan_required` UX surface for the checkout pages.
 *
 * - Guest (`isLogged === false`): calls `requireLoginAction()` and renders nothing.
 *   The global `LoginRegisterDialog` (mounted in `AuthProvider`) opens.
 * - Authenticated non-plus: mounts `<AcquirePlusDialog open />`.
 *   Plus users cannot reach this branch (the backend bypasses them, see
 *   `cart-checkout` FR-12).
 */
export const PlanRequiredErrorView: React.FC = () => {
    const { isLogged, requireLoginAction } = useAuth();

    useEffect(() => {
        if (!isLogged) {
            requireLoginAction();
        }
    }, [isLogged, requireLoginAction]);

    if (!isLogged) {
        return null;
    }

    return (
        <AcquirePlusDialog
            open
            onOpenChange={() => {
                /* v1: navigation owns close; no-op keeps the dialog mounted. */
            }}
        />
    );
};
